var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m221.647 0c-122.214 0-221.647 99.433-221.647 221.647s99.433 221.647 221.647 221.647 221.647-99.433 221.647-221.647-99.433-221.647-221.647-221.647zm0 415.588c-106.941 0-193.941-87-193.941-193.941s87-193.941 193.941-193.941 193.941 87 193.941 193.941-87 193.941-193.941 193.941z","key":0}),React.createElement("path",{"d":"m235.5 83.118h-27.706v144.265l87.176 87.176 19.589-19.589-79.059-79.059z","key":1})]);
}

Clock.defaultProps = {"id":"Capa_1","enableBackground":"new 0 0 443.294 443.294","height":"512","viewBox":"0 0 443.294 443.294","width":"512"};

module.exports = Clock;

Clock.default = Clock;
